export default __webpack_public_path__ + "static/media/S_CoreDream_9Black.82fee75b.woff";